import { ListBox, ListBoxChangeEvent } from "primereact/listbox"
import { GroupType, PermissionType } from "../../db/Orm"
import { useEffect, useReducer, useRef } from "react"
import { Toast } from "primereact/toast"
import { Button } from "primereact/button"
import API from "../../api/API"
import { Chip } from "primereact/chip"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { ProgressSpinner } from "primereact/progressspinner"
import { AxiosError } from "axios"
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch"
import Auth from "../../auth/Authenticator"

enum ACTIONS {
    selectGroup,
    selectPerms,
    setLoading,
    setShowAll,
    reset
}
type Props = {
    groups: GroupType[]
    permissions: PermissionType[]
    toast?: Toast | null
}
type RStateType = {
    selectedGroup: GroupType | null
    selectedPerms: PermissionType[]
    loading: boolean
    showAll: boolean
}
type actionType = {
    T: ACTIONS,
    load: any,
    extra?: any
}
const initialState: RStateType = {
    selectedGroup: null,
    selectedPerms: [],
    loading: true,
    showAll: false
}
const reducerFunction = (state: RStateType, action: actionType): RStateType => {
    switch (action.T) {
        case ACTIONS.selectGroup:
            return { ...state, selectedGroup: action.load }
        case ACTIONS.selectPerms:
            return { ...state, selectedPerms: action.load, loading: action.extra === undefined ? state.loading : action.extra }
        case ACTIONS.setLoading:
            return { ...state, loading: action.load }
        case ACTIONS.setShowAll:
            return { ...state, showAll: action.load }
        case ACTIONS.reset:
            return initialState
    }
    return initialState
}
export default function TabPermissoes(props: Props) {
    const auth = Auth.useAuth()
    const [state, dispatch] = useReducer(reducerFunction, initialState)
    const toastRef = useRef<Toast>(null)
    const loadPermsRef = useRef<Map<string, PermissionType>>()
    const filteredPermsRef = useRef<PermissionType[]>([])
    const checkBoxRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        (async () => {
            if (!state.selectedGroup) return
            // if (!global.) return
            const groupPerms = await API.getGroupPerms(state.selectedGroup)
            const preSelect: PermissionType[] = []
            loadPermsRef.current = new Map()
            groupPerms.forEach((v) => {
                const perm = props.permissions.filter((p) => p.string_perm === v.string_perm)[0]
                if (perm) {
                    preSelect.push(perm)
                    loadPermsRef.current?.set(v.string_perm, perm)
                }
            })
            dispatch({ T: ACTIONS.selectPerms, load: preSelect, extra: false })
        })()
    }, [state.selectedGroup])
    useEffect(() => {
        filteredPermsRef.current = props.permissions.filter((p) => p.string_perm.startsWith('monitorabahia'))
    }, [props.permissions])
    const onListBoxChange = (e: ListBoxChangeEvent) => {
        console.log('onListBoxChange', e.value)
        if (!auth.hasPermission('auth.view_permission')) {
            toastRef.current?.show({ severity: 'error', summary: 'Erro de permissão', detail: 'Permissão de acesso insuficiente.' })
            return
        }
        dispatch({ T: ACTIONS.selectGroup, load: e.value })
    }
    const onSalvar = async () => {
        const grupo = state.selectedGroup
        if (!grupo) return
        // const grupoId = state.selectedGroup?.id
        // if (!grupoId) return
        const _cb = checkBoxRef.current
        _cb && (_cb.scrollTop = 0)
        dispatch({ T: ACTIONS.setLoading, load: true })
        //console.log('Selecionados', state.selectedPerms)
        const mappedSelectedPerms = new Map()
        state.selectedPerms.forEach((p) => mappedSelectedPerms.set(p.string_perm, p))
        const adicionados: PermissionType[] = []
        const removidos: PermissionType[] = []
        props.permissions.forEach((p) => {
            if (mappedSelectedPerms.has(p.string_perm) && !loadPermsRef.current?.has(p.string_perm))
                adicionados.push(p)
            if (loadPermsRef.current?.has(p.string_perm) && !mappedSelectedPerms.has(p.string_perm))
                removidos.push(p)
        })
        //console.log('Adicionados', adicionados)
        //console.log('Removidos', removidos)
        try {
            await API.addGroupPerms(grupo, adicionados)
            const newGroupPerms = await API.removeGroupPerms(grupo, removidos)
            props.toast?.show({severity: 'success', summary: 'Permissões', detail: 'Alterações aplicadas com sucesso.'})
            const groupPermsArray = newGroupPerms.map(v=>v.string_perm)
            auth.setPermissions(groupPermsArray)
            // if (global.user?.groups?.[0]?.id === grupoId){
            //     global.userPerms = newGroupPerms
            //     global.mappedUserPerms = new Map<string, PermissionType>()
            //     newGroupPerms.forEach((p)=>global.mappedUserPerms.set(p.string_perm, p))
            // }
            dispatch({ T: ACTIONS.reset, load: null })
        } catch (error) {
            const e = error as AxiosError
            console.error(e)
            toastRef.current?.show({ severity: 'error', summary: 'Erro', detail: e.message })
            dispatch({ T: ACTIONS.setLoading, load: false })
        }
    }
    const checkBoxItemTemplate = (perm: PermissionType) => {
        return <><Chip label={perm.string_perm} /><p>{perm.name}</p></>
    }
    // const checkBoxPerms = 
    return <div className='tab-permissoes'>
        {!state.selectedGroup &&
            <ListBox options={props.groups} optionLabel='name' value={state.selectedGroup}
                onChange={onListBoxChange} />}
        {state.selectedGroup &&
            <>
                <div className={'checkbox-perms'} style={{ overflow: state.loading ? 'hidden' : 'scroll' }}
                    ref={checkBoxRef}>
                    <div className='checkbox-loadblock' style={{ display: state.loading ? 'flex' : 'none' }}>
                        <ProgressSpinner />
                    </div>
                    <DataTable disabled={state.loading} value={state.showAll ? props.permissions : filteredPermsRef.current}
                        size='small' selectionMode={null} selection={state.selectedPerms} filterDisplay='row'
                        onSelectionChange={(e) => dispatch({ T: ACTIONS.selectPerms, load: e.value })}>
                        <Column filter filterField='string_perm' body={checkBoxItemTemplate} header={`Permissões de ${state.selectedGroup?.name}`}
                            filterMatchMode='contains' showFilterMenu={false} />
                        <Column selectionMode='multiple' />
                    </DataTable>
                </div>
                <div className='checkbox-buttons'>
                    <InputSwitch checked={state.showAll} tooltip='Mostrar permissões de sistema'
                        tooltipOptions={{ position: 'top' }}
                        onChange={(e: InputSwitchChangeEvent) => { dispatch({ T: ACTIONS.setShowAll, load: e.value }) }} />
                    {auth.hasPermission('auth.edit_group_permissions') && <Button label='Salvar' onClick={onSalvar} disabled={state.loading} />}
                    <Button label='Sair' onClick={() => dispatch({ T: ACTIONS.reset, load: null })} severity='secondary' />
                </div>
            </>
        }
    </div>
}